import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import getMenuEnties from '../components/Menu/data';
import { appCodeSelector } from '../store/form/selectors';
import { updateCoords, updateField } from '../store/form/thunks';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { sendMessageToParent } from '../utils/iframeMessage';
import { useConfig } from './useConfig';

const useOnloadActions = () => {
    const dispatch = useAppDispatch();
    const searchParams = useSearchParams();
    const appCode = useAppSelector(appCodeSelector);
    const { defaultGeoPoint } = useConfig();
    const [params] = searchParams;
    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        const type = params.get('type');

        const isTypeAvailable = getMenuEnties(appCode).filter(({ id }) => id === type).length > 0;
        if (isTypeAvailable && type) dispatch(updateField('type', type));

        const CLID = params.get('ref');
        if (CLID) dispatch(updateField('clid', CLID));

        // Iframe message
        sendMessageToParent();

        // получение тарифов для координат по-умолчанию
        dispatch(updateCoords(defaultGeoPoint));
    }, []);
    /* eslint-enable react-hooks/exhaustive-deps */
};

export default useOnloadActions;
